import styled from 'styled-components';

export const Wrapper = styled.button<{
  outlined?: boolean;
}>`
  height: 44px;
  width: 100%;
  padding: 0 16px;
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: center;
  border: 1px solid #5b36f2;
  border-radius: 4px;
  background-color: ${(props) => (props.outlined ? '#ffffff' : '#5b36f2')};
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  text-align: center;
  color: ${(props) => (props.outlined ? '#5b36f2' : '#ffffff')};

  > cc-icon {
    color: ${(props) => (props.outlined ? '#5b36f2' : '#ffffff')};
  }

  > span {
    font-size: 14px;
    font-weight: 700;
    line-height: 20px;
    text-align: center;
    color: ${(props) => (props.outlined ? '#5b36f2' : '#ffffff')};
  }

  &:hover {
    background-color: ${(props) => (props.outlined ? '#E2DFFD' : '#745EF6')};
    border: 1px solid ${(props) => (props.outlined ? '#5b36f2' : '#745EF6')};
  }

  &:active,
  &:focus {
    background-color: ${(props) => (props.outlined ? '#C6C0FC' : '#4318CD')};
    border: 1px solid ${(props) => (props.outlined ? '#5b36f2' : '#4318CD')};
  }

  &:disabled {
    cursor: no-drop;
    color: #8090bb;
    background-color: ${(props) =>
      props.outlined ? 'transparent' : '#D5E5F0'};
    border: 1px solid ${(props) => (props.outlined ? '#8090BB' : '#D5E5F0')};

    > cc-icon {
      color: #8090bb;
    }

    > span {
      color: #8090bb;
    }
  }

  @media (min-width: 640px) {
    width: max-content;
  }
`;
